(function () {
  'use strict';

  function init() {
    var form = document.querySelector('form[data-lumen-preorder]');
    if (!form) return;

    var submitBtn = form.querySelector('.lumen-preorder__submit');
    var submitLabel = form.querySelector('.lumen-preorder__submit-label');
    var errorEl = form.querySelector('.lumen-preorder__error');
    var termsCheckbox = form.querySelector('input[name="terms_accepted"]');

    function computeValid() {
      return form.checkValidity() && termsCheckbox.checked;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!computeValid()) {
        var firstInvalid = form.querySelector(':invalid');
        if (firstInvalid) {
          firstInvalid.focus();
          errorEl.textContent = 'Please complete every field and accept the Terms of Reservation.';
        } else if (!termsCheckbox.checked) {
          termsCheckbox.focus();
          errorEl.textContent = 'Please accept the Terms of Reservation to continue.';
        }
        return;
      }

      var variantId = Number(form.dataset.variantId);
      if (!variantId) {
        errorEl.textContent = 'Reservation is temporarily unavailable. Please contact info@uvceed.com.';
        return;
      }

      errorEl.textContent = '';
      submitBtn.disabled = true;
      submitBtn.setAttribute('aria-disabled', 'true');
      if (submitLabel) submitLabel.textContent = 'Reserving…';

      var payload = {
        items: [{
          id: variantId,
          quantity: 1,
          properties: {
            'Company': (form.company_name.value || '').trim(),
            'Facility Type': form.facility_type.value,
            'Estimated Fixtures': form.fixture_count.value,
            'Contact Email': (form.contact_email.value || '').trim(),
            'Terms Accepted At': new Date().toISOString()
          }
        }]
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (body) {
              var message = (body && body.description) || 'Unable to add reservation to cart.';
              throw new Error(message);
            });
          }
          return res.json();
        })
        .then(function () {
          window.location.href = form.dataset.successRedirect || '/checkout';
        })
        .catch(function (err) {
          errorEl.textContent = err.message || 'Something went wrong. Please try again.';
          submitBtn.disabled = false;
          submitBtn.removeAttribute('aria-disabled');
          if (submitLabel) submitLabel.textContent = 'Reserve now';
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
